import { ElementList } from '@/interfaces/administration/administration';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArray',
})
export class FilterArrayPipe implements PipeTransform {

  transform(value: ElementList[], args: string): ElementList[] {
    if (!value) return value;
    if (!args) return value;
    // eslint-disable-next-line no-param-reassign
    args = args.toLocaleLowerCase();

    return value.filter((el) => JSON.stringify(el.name).toLowerCase().includes(args));
  }

}
